import {SponsorTypeEnum} from 'modules/coupons/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface PermissionProps {
  [key: string]: string[];
}

export interface PermissionGroupProps {
  id: string;
  name: string;
  permissions: PermissionProps[];
  type: SponsorTypeEnum;
}

export const translatedPermissionGroupProps: TranslatedKeys<PermissionGroupProps> =
  {
    name: 'Nome',
    permissions: 'Permissões',
    type: 'Tipo',
  };
